<template>
	<SelfSignupPage />
</template>

<script>
import SelfSignupPage from '@/components/self-signup/SelfSignupPage.vue';

export default {
	name: 'SelfSignup',
	components: { SelfSignupPage },
};
</script>
